// extracted by mini-css-extract-plugin
module.exports = {"toc":"DocToc_toc__f8JmB","title":"DocToc_title__pqw5F","grid":"DocToc_grid__tN3aY","item":"DocToc_item__HlDsZ","link":"DocToc_link__AhST7","label":"DocToc_label__ca4mf"};